import {getAllCustomerMain} from '../../services/CustomerMainServices'

export function formatSiteNameWithAddress(site = {}) {
  const parts = [site.site_name, site.address_1, site.address_2, site.address_3]
    .map((value) => (value ? String(value).trim() : ''))
    .filter(Boolean);
  return parts.join(', ');
}

export function formatSiteProjectName(site = {}) {
  return site.project_name ? String(site.project_name).trim() : '';
}

export function getUpDownKm(site = {}) {
  const storedKm = Number(site.radius_distance || 0);
  return Number.isFinite(storedKm) ? storedKm.toFixed(2) : '0.00';
}

export function emptySiteFormValues() {
  return {
    site_name: '',
    name: '',
    address_1: '',
    address_2: '',
    address_3: '',
    site_pincode: '',
    pincode: '',
    plant_id: '',
    site_area: '',
    site_street: '',
    phone_number: '',
    mobile_number: '',
    site_email_id: '',
    radius_distance: 0,
    estimated_travel_mins: 0,
    project_name: '',
    contact_person: '',
    contact_designation: '',
    site_contact_email_id: '',
    user_remarks: '',
    contact_mobile_no: '',
    site_gst_no: '',
    site_pan_no: '',
    state: '',
    status: 'true',
  };
}

export function applySiteLocationUpdates(updates) {
  const next = { ...updates };
  if ('site_pincode' in next) {
    next.pincode = next.site_pincode;
  }
  return next;
}

export function checkDuplicateCustomerMain(name, value, cookies, existingId) {
    
    
    let nameCheck = new Promise((resolve, reject) => {
        getAllCustomerMain(cookies)
      .then((data) => {

        let isUserExists = false;
        data.customer_list.forEach(customer =>{ //Same Customer Name mentioned it denoted already exist.
        
          if((customer.name) === value.trim().toUpperCase()
            && parseInt(existingId) !== customer.id){   
            
            console.log(`Customer exists with the name - ${value}`) 
            isUserExists = true;
       
          }
        
      })
        resolve(isUserExists);
      });  
    });

    return nameCheck;
  }